module.exports = __webpack_public_path__ + "img/icon_playbtn.b4db8c91.svg";